import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "RotateClockwise"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 22.5H12C11.1719 22.4992 10.5008 21.8281 10.5 21V12C10.5008 11.1719 11.1719 10.5008 12 10.5H21C21.8281 10.5008 22.4992 11.1719 22.5 12V21C22.4992 21.8281 21.8281 22.4992 21 22.5ZM12 12V21H21.0008L21 12H12ZM11.25 1.5L10.1925 2.5575L12.1275 4.5H8.25C5.35188 4.50331 3.00331 6.85188 3 9.75V13.5H4.5V9.75C4.50248 7.67996 6.17996 6.00248 8.25 6H12.1275L10.1925 7.9425L11.25 9L15 5.25L11.25 1.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/RotateClockwise.vue"]]);
